import { NgModule } from "@angular/core";
import { CoreModule } from "@modules/core/core.module";
import { VisionSummaryTotalComponent } from "./vision-summary-total.component";

@NgModule({
	declarations: [VisionSummaryTotalComponent],
	imports: [CoreModule],
	exports: [VisionSummaryTotalComponent]
})
export class VisionSummaryTotalModule {}
